export default __webpack_public_path__ + "3697f5f6f364ac71fb6a242c7e130871.png";